import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';

import { ContaService } from '../../../../shared/services/conta/conta.service';
import { LoginService } from './../../../../shared/services/auth/login/login.service';
import { LocalStorageService } from '../../../../shared/services/local-storage/local-storage.service';
import { AuthorizationData } from '../../../../shared/services/auth/login/login.interface';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  public email = '';
  public password = '';
  public error = false;
  public success = false;
  public responseMessage = '';
  public loginTransiente = false;
  public unsubscriber = new Subject();

  constructor(
    private router: Router,
    private elRef: ElementRef,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private contaService: ContaService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    if (this.isLoggedIn()) { this.router.navigate(['/visao-geral']); }
    this.email = this.route.snapshot.params['email'] ? this.route.snapshot.params['email'] : this.email;

    this.route.params.pipe(takeUntil(this.unsubscriber)).subscribe((params) => {
      const sid = params['sid'];
      const uid = params['uid'];

      if (sid && uid) {
        this.loginAutomaticoSid(sid, uid);
      }
    });
  }

  public loginAutomaticoSid(sid: string, uid: string): void {
    const data: any = {
      sid,
      uid
    };

    this.loginTransiente = true;

    this.loginService.loginByCodeTemp(data).pipe(takeUntil(this.unsubscriber)).subscribe((response) => {
      this.localStorageService.set('login', response);
      this.getAccount(response.PersonId);
    }, (error) => {
      setTimeout(() => {
        this.router.navigate(['/login']).then();
      }, 3000);
      this.error = true;
      this.responseMessage = 'Ocorreu um erro interno no servidor.';

      if (error && error.error && error.error.ValidationResult && error.error.ValidationResult.Errors && error.error.ValidationResult.Errors[0] && error.error.ValidationResult.Errors[0].ErrorMessage) {
        this.responseMessage = error.error.ValidationResult.Errors[0].ErrorMessage;
      }

      this.loginTransiente = false;
      console.error(error);
    });
  }

  ngOnDestroy(): void {
    this.unsubscriber.next(null);
    this.unsubscriber.complete();
  }

  isLoggedIn() {
    return this.localStorageService.get('login') ? true : false;
  }

  doLogin() {
    this.error = false;
    this.success = false;
    this.enableLoading();

    if (!this.hasEmailAndPassword()) {
      this.error = true;
      this.responseMessage = 'Os campos E-mail e Senha são obrigatórios.';
      this.disableLoading();
      return;
    }

    this.loginService.login(this.email, this.password)
      .subscribe((data: AuthorizationData) => {
        this.success = true;
        this.localStorageService.set('login', data);

        this.getAccount(data.PersonId);
      }, (error) => {
        this.error = true;
        console.error(error);

        const msgErro = 'Ocorreu um erro interno no servidor.';

        if (error.status === 403) {
          this.responseMessage = 'Conta inativa';
          this.disableLoading();
          return;
        }

        if (error && error.error && error.error.errors && error.error.errors.DomainValidations && error.error.errors.DomainValidations.length > 0) {
          this.responseMessage = error.error.errors.DomainValidations[0];
          this.disableLoading();
          return;
        }

        if (error && error.error && error.error.ModelState && error.error.ModelState.Erros && error.error.ModelState.Erros.length > 0) {
          this.responseMessage = error.error.ModelState.Erros[0];
          this.disableLoading();
          return;
        }

        if (error && error.error && error.error.Message && error.error.Message === 'An error has occurred.') {
          this.responseMessage = msgErro;
          this.disableLoading();
          return;
        }

        if (!error || !error.error) {
          this.responseMessage = msgErro;
          this.disableLoading();
          return;
        }

        if (error && error.error.type === 'error') {
          this.responseMessage = msgErro;
          this.disableLoading();
          return;
        }

        if (error && error.error && error.error.Errors && error.error.Errors.Password && error.error.Errors.Password[0]) {
          this.responseMessage = error.error.Errors.Password[0];
          this.disableLoading();
          return;
        }

        if (error && error.error && error.error.Errors && error.error.Errors.Email && error.error.Errors.Email[0]) {
          this.responseMessage = error.error.Errors.Email[0];
          this.disableLoading();
          return;
        }

        if (error && error.error && error.error.errors && error.error.errors.Password && error.error.errors.Password[0]) {
          this.responseMessage = error.error.errors.Password[0];
          this.disableLoading();
          return; 
        }

        if (error && error.error && error.error.errors && error.error.errors.Email && error.error.errors.Email[0]) {
          this.responseMessage = error.error.errors.Email[0];
          this.disableLoading();
          return; 
        }

        this.disableLoading();
      });
  }

  hasEmailAndPassword() {
    return this.email && this.password ? true : false;
  }

  getAccount(id) {
    this.contaService.obterConta(id).subscribe((data: any) => {
      if (data && data.TipoCadastro !== 'PagueLa') {
        this.isSetupCompeted(data) ? this.router.navigate(['/visao-geral']) :  this.router.navigate(['/setup', data.ContaId]);
      } else {
        this.router.navigate(['/visao-geral']);
      }
    }, (err) => {
      this.responseMessage = err.status === 404 ? 'Conta não encontrada' : 'Não foi possível realizar o login';
      this.localStorageService.set('login', null);
      this.disableLoading();
      this.error = true;
      console.error(err);
    });
  }

  isSetupCompeted(data) {
    return data.Adquirentes.length > 0 ? true : false;
  }

  forgotPassword() {
    this.email ? this.router.navigate(['/recuperar-senha', this.email]) : this.router.navigate(['/recuperar-senha']);
  }

  enableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.add('loading');
    this.elRef.nativeElement.querySelector('.btn-registrar').style.opacity = '1';
  }

  disableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.remove('loading');
  }
}
